var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinSocialLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.54352 9.74804H0.883411V29.9998H7.54352V9.74804Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4009 11.5979C28.0019 10.0515 26.1515 9.27822 23.8509 9.27822C23.0033 9.27822 22.2328 9.38379 21.5397 9.59509C20.8469 9.80625 20.2617 10.1025 19.7839 10.484C19.3064 10.8655 18.9261 11.2197 18.6438 11.5465C18.3753 11.857 18.1128 12.2186 17.8566 12.6277V9.74791H11.2163L11.2367 10.729C11.2503 11.3831 11.2571 13.3993 11.2571 16.7779C11.2571 20.1568 11.2436 24.564 11.2166 30H17.8566V18.6987C17.8566 18.004 17.9302 17.4524 18.0785 17.0433C18.3612 16.3482 18.788 15.7661 19.3602 15.2963C19.9322 14.8259 20.6418 14.5909 21.4897 14.5909C22.6465 14.5909 23.4978 14.9962 24.0428 15.8068C24.5876 16.6174 24.86 17.738 24.86 19.1686V29.9994H31.5V18.3925C31.4995 15.4085 30.8004 13.1438 29.4009 11.5979Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25384 0C3.13722 0 2.23247 0.33062 1.53935 0.991217C0.846309 1.65196 0.5 2.48613 0.5 3.49453C0.5 4.48882 0.836342 5.32013 1.5091 5.98753C2.18164 6.65499 3.06979 6.98891 4.17304 6.98891H4.21341C5.34374 6.98891 6.25542 6.65528 6.94825 5.98753C7.64108 5.32013 7.98075 4.48911 7.96739 3.49453C7.95396 2.4862 7.61062 1.65196 6.93807 0.991217C6.2656 0.330334 5.37053 0 4.25384 0Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinSocialLogo);
export default __webpack_public_path__ + "static/media/linkedin-social-logo.1316fe5379444de12f3474f40a37e869.svg";
export { ForwardRef as ReactComponent };